import { apiSlice } from "../../app/services/authServices";
export const cycleListApiSlice = apiSlice.injectEndpoints({
    tagTypes: [],
    endpoints: builder => ({

        getDriverList: builder.query({
            query: () => ({
                url: '/Order/GetDriverList',
                method: 'GET',
                keepUnusedDataFor: 0,
                // providesTags: [],
            }),
        }),

    })
})
export const { useGetDriverListQuery } = apiSlice;

